import React, { useState, useEffect, useRef, useContext, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useSnackbar } from 'notistack'
import StoreContext from '../../../store/Context'
import { CustomThemeContext } from '../../../store/Theme'
import i18n from '../../../i18n'
import api from '../../../services/api'
import messages from '../../../services/messages'
import { useSelector, useDispatch } from 'react-redux'
import { setActiveAvailability } from '../../../redux/availabilities/actions'
import storage from '../../../utils/storage'

import {
  SwipeableDrawer,
  Grow,
  List,
  ListItem,
  ListItemSecondaryAction,
  ListItemIcon,
  Divider,
  Collapse,
  ClickAwayListener,
} from '@material-ui/core'

import { useTheme } from '@material-ui/core/styles'

import {
  BarChartRounded as ChartIcon,
  ExitToAppRounded as ExitIcon,
  SettingsRounded as SettingsIcon,
  VolumeOffRounded as MuteSoundIcon,
  VolumeUpRounded as SoundIcon,
  Brightness7Rounded as SunIcon,
  Brightness4Rounded as MoonIcon,
  LanguageRounded as LanguageIcon,
  ExpandLessRounded as LessIcon,
  ExpandMoreRounded as MoreIcon,
  RadioButtonCheckedRounded as CheckBoxCheckedIcon,
  RadioButtonUncheckedRounded as CheckBoxIcon,
} from '@material-ui/icons'
import SendIcon from '@material-ui/icons/Send'

import UserSettings from '../drawers/userSettings'
import ButtonStatus from '../../atoms/inputs/buttonStatus'
import Button from '../../atoms/inputs/button'
import Switch from '../../atoms/inputs/switch'
import SearchField from '../../atoms/inputs/searchField'
import Typography from '../../atoms/display/typography'
import Icon from '../../atoms/display/icon'
import Alert from '../../molecules/feedback/dialogs/alert'
import Audio from '../../atoms/feedback/audio'

import useStyles from './userMenuStyle'

import { setUserPreferences } from '../../../redux/userPreferences/actions'
import { updateMetrics } from '../../../redux/goals/actions'
import { getAvailability } from '../../../utils/customMethods'

const UserMenu = (props) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const { enqueueSnackbar } = useSnackbar()
  let useStylesParams = {
    space: props?.space,
  }
  const classes = useStyles(useStylesParams)
  const theme = useTheme()
  const userPreferences = useSelector((state) => state.userPreferences.data)
  const conversations = useSelector(
    (state) => state.conversations.conversations
  )
  const [drawerLeft, setDrawerLeft] = useState(false)
  const [alertLoading, setAlertLoading] = useState(false)
  const [alertOpen, setAlertOpen] = useState(false)
  const [reasonsOpen, setReasonsOpen] = useState(false)
  const [reasonFather, setReasonFather] = useState()
  const [reasonChildrens, setReasonChildrens] = useState([])
  const [reasonChildrensSearch, setReasonChildrensSearch] = useState([])
  const [availabilityName, setAvailabilityName] = useState()
  const [soundSwitch, setSoundSwitch] = useState(
    storage.get('volume') > 0 && true
  )
  const [themeSwitch, setThemeSwitch] = useState(false)
  const [hotkeySwitch, setHotkeySwitch] = useState(
    userPreferences?.msgHotkey === 'Enter'
  )
  const [expandedMenu, setExpandedMenu] = useState(0)
  const [availabilitiesLoadingId, setAvailabilitiesLoadingId] = useState()
  const [availabilitiesLoading, setAvailabilitiesLoading] = useState(false)
  const [languageSelected, setLanguageSelected] = useState('')
  const { currentTheme, setTheme } = useContext(CustomThemeContext)
  const { token, setToken } = useContext(StoreContext)
  const { data: availabilities, activeAvailability: activeAvailabilityId } =
    useSelector((state) => state.availabilities)
  const inputSearchRef = useRef()

  const activeAvailability = useMemo(() => {
    if (activeAvailabilityId) {
      return getAvailability(availabilities, activeAvailabilityId)
    }
    return null
  }, [availabilities, activeAvailabilityId])

  const isHasConversationsOpen = useMemo(()=>{    
    let isActive = false;
    const statusCvs = ['active','inactive','pre-chat'];
    Object.keys(conversations).forEach((valu)=>{
      if(statusCvs.includes(conversations[valu]?.status)){
        isActive = true;
      }      
    });   

   return isActive;
  },[conversations]);

  useEffect(() => {
    setLanguageSelected(i18n.language)
  }, [])

  useEffect(() => {
    currentTheme === 'dark' ? setThemeSwitch(true) : setThemeSwitch(false)
  }, [currentTheme])

  useEffect(() => reasonsOpen && search(), [reasonsOpen])

  const handleCollapseMenu = (index) => {
    setExpandedMenu({
      [index]: expandedMenu[index] === true ? false : true,
    })
  }

  const search = () => {
    if (inputSearchRef?.current?.value) {
      setReasonChildrensSearch([])
      const regex = new RegExp(inputSearchRef?.current?.value, 'i')
      setReasonChildrensSearch(
        reasonChildrens.filter((item) =>
          regex.test(item.name.normalize('NFD').replace(/[\u0300-\u036f]/g, ''))
        )
      )
    } else {
      setReasonChildrensSearch([])
    }
  }

  const handleSwitchSound = (event) => {
    setSoundSwitch(event.target.checked)
    Audio.setVolume(soundSwitch ? 0 : 100)
  }
  const handleSwitchTheme = (event) => {
    event.target.checked === true ? setTheme('dark') : setTheme('normal')
    setThemeSwitch(currentTheme === 'dark' ? true : false)
  }
  const handleSwitchHotkey = (event) => {
    userPreferences.msgHotkey = event.target.checked ? 'Enter' : 'CtrlEnter'
    setHotkeySwitch((prev) => !prev)
    dispatch(setUserPreferences(userPreferences))
  }

  const signOut = () => {
    setAlertLoading(true)
    localStorage.removeItem('token')
    localStorage.removeItem('state')
    dispatch({ type: 'LOGOUT' })
    api({
      method: 'POST',
      url: '/user/logout',
    }).then((response) => {
      setAlertLoading(false)
      setToken(null)
      delete api.defaults.headers.common['Authorization']
      delete messages.defaults.headers.common['Authorization']
    })
  }

  const translateStatus = (name) => {
    if (name === 'Online') return 0
    if (name === 'Volto logo') return 1
    if (name === 'Ausente') return 3
  }

  const translateName = (name) => {
    if (name === 'Online') return 'Atendendo'
    if (name === 'Volto logo') return 'Pré-pausa'
    if (name === 'Ausente') return 'Pausa'
  }

  const updateStatus = (father, availability_id, availability_name) => {
    const oldActiveAvail = activeAvailabilityId
    setAvailabilitiesLoading(true)
    setAvailabilitiesLoadingId(father ? father : availability_id)
    dispatch(setActiveAvailability(null))
    api({
      method: 'PATCH',
      url: '/user/status',
      data: { availability_id: availability_id },
    })
      .then((response) => {
        if (availability_name) {
          setAvailabilityName(availability_name)
        } else {
          setAvailabilityName()
        }

        setAvailabilitiesLoading(false)
        setAvailabilitiesLoadingId(null)
        if (response.data.error === false) {
          props.open(false)
          dispatch(setActiveAvailability(availability_id))
          setTimeout(() => dispatch(updateMetrics()), 1000)
        }
      })
      .catch((error) => {
        enqueueSnackbar(`${t('toasts.availabilityError')}`, {
          variant: 'error',
        })
        setAvailabilitiesLoading(false)
        setAvailabilitiesLoadingId(null)
        dispatch(setActiveAvailability(oldActiveAvail))
      })
  }

  const configureReasons = (father, childrens) => {
    setReasonChildrensSearch([])
    setReasonFather(father)
    if (childrens) {
      setReasonsOpen(reasonsOpen ? false : true)
      setReasonChildrens(childrens)
    } else {
      setReasonFather()
      setReasonsOpen(false)
      setReasonChildrens([])
      updateStatus(null, father)
    }
  }

  const renderAvailabilities = () => {
    if (availabilities) {
      return (
        <>
          {availabilities.map((el) => {
            return (
              <div key={el.id}>
                <ButtonStatus
                  size="large"
                  color="primary"
                  fullWidth
                  variant="outlined"
                  active={activeAvailability?.typeInfo === el.name}
                  status={translateStatus(el.name)}
                  text={availabilityName}
                  description={activeAvailability?.description}
                  more={el?.children?.length}
                  onClick={() => configureReasons(el.id, el.children)}
                  loading={
                    availabilitiesLoadingId === el.id && availabilitiesLoading
                      ? true
                      : false
                  }
                >
                  {translateName(el.name)}
                </ButtonStatus>
                <div style={{ height: 10 }} />
              </div>
            )
          })}
        </>
      )
    }
  }

  const renderReasons = () => {
    if (reasonsOpen) {
      return (
        <>
          <Grow in={true}>
            <div className={classes.reasons}>
              <div className={classes.reasonsHeader}>
                <Typography
                  variante="body1"
                  style={{
                    color: theme.palette.primary.secondary,
                    fontWeight: theme.typography.fontWeightBold,
                  }}
                >
                  {t('commons.reasonsTitlePanel')}
                </Typography>
              </div>
              <div className={classes.reasonsSearch}>
                <SearchField
                  id="field-search"
                  label={t('fields.search.label')}
                  placeholder={t('fields.search.placeHolder')}
                  type="text"
                  color="primary"
                  variant="outlined"
                  name="searchAgent"
                  inputRef={inputSearchRef}
                  shrink={true}
                  fullWidth={true}
                />
                <Button
                  size="large"
                  variant="contained"
                  color="primary"
                  border="rounded"
                  style={{ marginLeft: 5, height: 42 }}
                  onClick={() => search()}
                >
                  {t('buttons.search')}
                </Button>
              </div>
              <div className={classes.reasonsContent}>
                <List
                  component="nav"
                  aria-label="secondary mailbox folders"
                  disablePadding
                >
                  {inputSearchRef?.current?.value?.length === 0
                    ? reasonChildrens?.map((el) => {
                        return (
                          <>
                            <ListItem
                              button
                              color="primary"
                              disablePadding
                              className={classes.listItem}
                              onClick={() =>
                                updateStatus(reasonFather, el.id, el.name)
                              }
                            >
                              <ListItemIcon>
                                {el.id === activeAvailabilityId ? (
                                  <CheckBoxCheckedIcon
                                    style={{
                                      color: theme.palette.primary.secondary,
                                    }}
                                  />
                                ) : (
                                  <CheckBoxIcon
                                    style={{
                                      color: theme.palette.primary.secondary,
                                    }}
                                  />
                                )}
                              </ListItemIcon>
                              <Typography
                                variante="body1"
                                style={{
                                  color: theme.palette.primary.secondary,
                                }}
                              >
                                {el.name}
                              </Typography>
                            </ListItem>
                          </>
                        )
                      })
                    : reasonChildrensSearch?.map((el) => {
                        if (el) {
                          return (
                            <>
                              <ListItem
                                button
                                color="primary"
                                disablePadding
                                onClick={() =>
                                  updateStatus(reasonFather, el.id)
                                }
                              >
                                <ListItemIcon>
                                  {el.id === activeAvailabilityId ? (
                                    <CheckBoxCheckedIcon
                                      style={{
                                        color: theme.palette.primary.secondary,
                                      }}
                                    />
                                  ) : (
                                    <CheckBoxIcon
                                      style={{
                                        color: theme.palette.primary.secondary,
                                      }}
                                    />
                                  )}
                                </ListItemIcon>
                                <Typography
                                  variante="body1"
                                  style={{
                                    color: theme.palette.primary.secondary,
                                  }}
                                >
                                  {el.name}
                                </Typography>
                              </ListItem>
                            </>
                          )
                        }
                      })}
                </List>
              </div>
            </div>
          </Grow>
        </>
      )
    }
  }

  return (
    <>
      <ClickAwayListener
        onClickAway={() => {
          if (!drawerLeft) {
            props.open(false)
          }
        }}
      >
        <Grow in={true}>
          <div className={classes.root}>
            <div style={{ margin: 15, marginBottom: 0 }}>
              <Icon text="Status" color={theme.palette.primary.secondary}>
                <ChartIcon style={{ color: 'rgba(28,48,89,.6)' }} />
              </Icon>
              <div style={{ height: 15 }} />
              {renderAvailabilities()}
              {renderReasons()}
              <div style={{ height: 5 }} />
              <Divider />
            </div>
            <List component="div">
              <ListItem
                button
                onClick={(e) => {
                  e.stopPropagation()
                  setDrawerLeft(true)
                }}
              >
                <ListItemIcon>
                  <SettingsIcon
                    style={{ color: theme.palette.primary.secondary }}
                  />
                </ListItemIcon>
                <Typography
                  variant="body1"
                  style={{ color: theme.palette.primary.secondary }}
                >
                  {t('buttons.settings')}
                </Typography>
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  {soundSwitch ? (
                    <SoundIcon
                      style={{ color: theme.palette.primary.secondary }}
                    />
                  ) : (
                    <MuteSoundIcon
                      style={{ color: theme.palette.primary.secondary }}
                    />
                  )}
                </ListItemIcon>
                <Typography
                  variant="body1"
                  style={{ color: theme.palette.primary.secondary }}
                >
                  {t('buttons.sounds')}
                </Typography>
                <ListItemSecondaryAction>
                  <Switch
                    name="sounds"
                    color="primary"
                    onChange={handleSwitchSound}
                    checked={soundSwitch}
                  />
                </ListItemSecondaryAction>
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  {currentTheme === 'dark' ? (
                    <MoonIcon
                      style={{ color: theme.palette.primary.secondary }}
                    />
                  ) : (
                    <SunIcon
                      style={{ color: theme.palette.primary.secondary }}
                    />
                  )}
                </ListItemIcon>
                <Typography
                  variant="body1"
                  style={{ color: theme.palette.primary.secondary }}
                >
                  {t('buttons.theme')}
                </Typography>
                <ListItemSecondaryAction>
                  <Switch
                    name="theme"
                    color="primary"
                    onChange={handleSwitchTheme}
                    checked={themeSwitch}
                  />
                </ListItemSecondaryAction>
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  <SendIcon
                    style={{ color: theme.palette.primary.secondary }}
                  />
                </ListItemIcon>
                <Typography
                  variant="body1"
                  style={{
                    color: theme.palette.primary.secondary,
                  }}
                >
                  {t('commons.sendWithEnter')}
                </Typography>
                <Switch
                  name="hotkey"
                  color="primary"
                  onChange={handleSwitchHotkey}
                  checked={hotkeySwitch}
                />
              </ListItem>
              <ListItem button onClick={() => handleCollapseMenu(1)}>
                <ListItemIcon>
                  <LanguageIcon
                    style={{ color: theme.palette.primary.secondary }}
                  />
                </ListItemIcon>
                <Typography
                  variant="body1"
                  style={{ color: theme.palette.primary.secondary }}
                >
                  {t('buttons.language')}
                </Typography>
                <ListItemSecondaryAction>
                  {expandedMenu[1] ? (
                    <LessIcon
                      style={{
                        color: theme.palette.primary.secondary,
                        marginTop: 4,
                      }}
                    />
                  ) : (
                    <MoreIcon
                      style={{
                        color: theme.palette.primary.secondary,
                        marginTop: 4,
                      }}
                    />
                  )}
                </ListItemSecondaryAction>
              </ListItem>
              <Collapse
                in={expandedMenu[1]}
                timeout="auto"
                unmountOnExit
                style={{ backgroundColor: 'rgba(0,0,0,.025)' }}
              >
                <List component="div" disablePadding>
                  <ListItem
                    button
                    onClick={() => {
                      i18n.changeLanguage('eng')
                      setLanguageSelected('eng')
                      setExpandedMenu(0)
                    }}
                  >
                    <ListItemIcon>
                      {languageSelected === 'eng' ? (
                        <CheckBoxCheckedIcon
                          style={{ color: theme.palette.primary.secondary }}
                        />
                      ) : (
                        <CheckBoxIcon
                          style={{ color: theme.palette.primary.secondary }}
                        />
                      )}
                    </ListItemIcon>
                    <Typography
                      variant="body1"
                      style={{ color: theme.palette.primary.secondary }}
                    >
                      {t('translations.english')}
                    </Typography>
                  </ListItem>
                  <ListItem
                    button
                    onClick={() => {
                      i18n.changeLanguage('pt')
                      setLanguageSelected('pt')
                      setExpandedMenu(0)
                    }}
                  >
                    <ListItemIcon>
                      {languageSelected === 'pt' ? (
                        <CheckBoxCheckedIcon
                          style={{ color: theme.palette.primary.secondary }}
                        />
                      ) : (
                        <CheckBoxIcon
                          style={{ color: theme.palette.primary.secondary }}
                        />
                      )}
                    </ListItemIcon>
                    <Typography
                      variant="body1"
                      style={{ color: theme.palette.primary.secondary }}
                    >
                      {t('translations.portuguese')}
                    </Typography>
                  </ListItem>
                </List>
              </Collapse>
              <ListItem button onClick={() => setAlertOpen(true)}>
                <ListItemIcon>
                  <ExitIcon style={{ color: theme.palette.error.main }} />
                </ListItemIcon>
                <Typography
                  variant="body1"
                  style={{ color: theme.palette.error.main }}
                >
                  {t('buttons.signout')}
                </Typography>
              </ListItem>
            </List>
          </div>
        </Grow>
      </ClickAwayListener>
      <SwipeableDrawer
        className={classes.drawerMenuRoot}
        anchor="left"
        open={drawerLeft ? drawerLeft : false}
        onClose={() => setDrawerLeft(false)}
        onOpen={() => setDrawerLeft(true)}
      >
        <UserSettings close={() => setDrawerLeft(false)} />
      </SwipeableDrawer>
      {alertOpen && !isHasConversationsOpen && (
        <Alert
          title={t('alerts.Attention')}
          text={t('alerts.signoutQuestion')}
          open={setAlertOpen}
          agreeAction={() => signOut()}
          loading={alertLoading}
        />
      )}

      {alertOpen && isHasConversationsOpen && (
        <Alert
          title={t('alerts.Attention')}
          text={t('alerts.signoutQuestionAttendance')}
          open={setAlertOpen}
          agreeAction={() => {}}
          loading={alertLoading}
          close
        />
      )}
    </>
  )
}

export default UserMenu
